<template functional>
    <div class="message" :class="props.type">
        <div class="message-content">
            <p class="margin-bottom-s"><strong>{{props.customer.displayName}}</strong></p>
            <p v-if="props.customer.email">{{props.customer.email}}</p>
            <p>{{props.customer.id}}</p>
        </div>
    </div>
</template>

<script>
    import CustomerModel from '@/common/models/customer-model';

    export default {
        name: 'merge-customer-summary',
        props: {
            type: String,
            customer: CustomerModel,
        },
    };
</script>
